import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getSession, SessionLogout } from "../session/session";
import { defaultSession } from "../session/lib";

export default function DefaultHome() {
  const navigate = useNavigate();

  useEffect(() => {
    getSession().then((sess) => {
      try {
        const data = JSON.parse(sess ? sess : JSON.stringify(defaultSession));
        if (data.isLoggedIn) {
          navigate("/work-contract-register");
        } else {
          SessionLogout();
          navigate("/login");
        }
      } catch (error) {
        SessionLogout();
        navigate("/login");
      }
    });
    // eslint-disable-next-line
  }, []);

  return <div>Redirecting to home page</div>;
}
